import TowerTable from "./TowerTable";
import {
  FormGroup,
  FormControlLabel,
  Grid,
  Stack,
  Switch,
} from "@mui/material";
import Component from "components/Component";
import Visible from "components/common/Visible";
import { useState } from "react";

export const BrokerTower = ({
  title = "Tower of Layers",
  subtitle = "The layers that are being placed in the market.",
}) => {
  const [isNet, setIsNet] = useState(false);
  return (
    <Component
      title={title}
      subtitle={subtitle}
      options={
        <Stack direction={"row"} alignItems={"center"} gap={3}>
          <Visible byTag={"<BrokerTower>.toggleNet"} defaultVisible>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={isNet}
                    onChange={(event) => setIsNet(event.target.checked)}
                    size={"small"}
                  />
                }
                label={"Net"}
                size={"small"}
              />
            </FormGroup>
          </Visible>
        </Stack>
      }
    >
      <Grid item>
        <TowerTable isNet={isNet} />
      </Grid>
    </Component>
  );
};

export default BrokerTower;
